import type { PresetLabelTreeNode } from '@loc/server/interface/preset'


import { cls } from 'tagged-classnames-free';
import { CssIcon } from '@/components/CssIcon';
interface TagGridProps {
  tags: PresetLabelTreeNode[]
  selectedTags: string[]
  onTagClick: (tag: PresetLabelTreeNode) => void
  onAuditionPlay?: (tag: PresetLabelTreeNode, isSelecting: boolean) => void
  className?: string
}

function TagGrid(props: TagGridProps) {
  const {
    tags,
    selectedTags,
    onTagClick,
    onAuditionPlay,
    className = '',
  } = props

  return (
    <div className={cls`flex flex-wrap gap-[10px] ${className}`}>
      {tags.map((tag) => {
        const isSelected = selectedTags.includes(tag.displayName)
        return (
          <button
            key={tag.code}
            type='button'
            className={cls`
              group/tag relative inline-flex cursor-pointer items-center gap-1 rounded
              px-3 py-1 text-sm transition-colors
              ${isSelected ? 'bg-f-primary-style-1 text-f-primary' : 'bg-f-bg-layout text-f-text-tertiary hover:text-f-primary'}
            `}
            onClick={() => {
              // isSelected 是点击前的状态，点击后会反转
              const willBeSelected = !isSelected
              onTagClick(tag)
              onAuditionPlay?.(tag, willBeSelected)
            }}
          >
            <span>{tag.displayName}</span>
            {/* 选中态减号 badge */}
            {isSelected && (
              <CssIcon
                className={cls`
                  bg-f-primary i-com--circle-gap-part-solid absolute -right-1.5 -top-1.5 size-3
                `}
              >
                -
              </CssIcon>
            )}
          </button>
        )
      })}
    </div>
  )
}

export default TagGrid
